/**
 * Access contexts for tasks
 */ export var TaskAccessContext;
(function(TaskAccessContext) {
    /* Plan based tasks access */ TaskAccessContext[TaskAccessContext["Plan"] = 0] = "Plan";
    /** Assignee based tasks access */ TaskAccessContext[TaskAccessContext["AssignedToUser"] = 1] = "AssignedToUser";
    /** My day based tasks access */ TaskAccessContext[TaskAccessContext["MyDay"] = 2] = "MyDay";
})(TaskAccessContext || (TaskAccessContext = {}));
